<template>
	<div class="v-clipboard">
		<div class="v-clipboard-content">
			<slot></slot>
		</div>
		<span 
			title="copiar" 
	    	v-clipboard:copy="text"
	    	v-clipboard:success="onCopy"
	    	v-clipboard:error="onError" 
	    	class="v-clipboard-copy cursor-pointer" 
	    	v-if="isValid">
	      	<i class="far fa-copy"></i>
	    </span>
	</div>
</template>
<script>
	export default{
		props: ['text', 'msg', 'msgFailed'],

		data(){
		    return {
		    	isValid: true,
		    }
		},

		mounted(){
			this.getIsValid();
		},
		
		methods: {
		    onCopy: function (e) {
		    	var msg = this.msg ? this.msg : 'El texto ha sido copiado en el portapapeles correctamente.';
		    	this.$toasted.show(msg);
		    },
		    onError: function (e) {
		      var msg = this.msgFailed ? this.msgFailed : 'Error al copiar en el portapapeles correctamente.';
		    	this.$toasted.show(msg);
		    },
		    getIsValid: function(){
		    	/*if(ClipboardJS.isSupported()){
					this.isValid = false;
				}*/
		    },
		}
	}
</script>
